import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';


@inject('companyStore')
@observer
class HomeView extends Component {

  render() {
    const { companyMain } = this.props.companyStore;
    return (
      <Fragment>
        {/* 
        <iframe allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" frameBorder="0" height="850" src="https://www.youtube.com/embed/EyI4rM74zU4?&amp;iv_load_policy=3&amp;mute=1&amp;volumn=0&amp;disablekb=1&amp;fs=0&amp;modestbranding=1&amp;autoplay=1&amp;controls=0&amp;showinfo=0&amp;wmode=opaque&amp;branding=0&amp;autohide=0&amp;playlist=KM6-ALjsygg&amp;loop=1&amp;enablejsapi=1&amp;widgetid=1&amp;vq=highres" title="YouTube video player" width="100%"></iframe>
        */}
        <br />
        {(companyMain !== null && companyMain.length > 0 && companyMain[0].cpImgInfo !== undefined && companyMain[0].cpImgInfo !== null)
        && 
          <span onClick={()=>this.props.history.push('/orderManage')}>
            <ImgView
              fileInfo={companyMain[0].cpImgInfo}
            />
          </span>
        }
      </Fragment>
    );
  }

}

export default withRouter(HomeView);
